import { useState } from "react";
import { RefreshCw, ArrowUpRight } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";
import { agentError } from "@/lib/agent";

export const SubtopicQueue = ({ articles, syntheses, load, onReview }) => {
  const [busy, setBusy] = useState("");
  const drafts = articles.filter(a => a.source_type === "synthesis_subtopic" && a.status === "borrador");
  const retry = async id => {
    setBusy(id);
    try {
      const { data } = await api.post(`/sintesis/${id}/subtopics`);
      if (data.status === "failed") throw new Error("No se completó la extracción. Intenta de nuevo.");
      toast.success(data.status === "no_sections" ? "No hay apartados con texto suficiente para extraer." : `${data.created} borradores nuevos · ${data.total} subtemas identificados`);
      await load();
    } catch (e) { toast.error(agentError(e)); }
    finally { setBusy(""); }
  };
  return <section className="subtopic-notice" data-testid="subtopics-review-summary">
    <div className="subtopic-sync-row"><span data-testid="subtopics-draft-count"><b>{drafts.length}</b> subtemas en borrador · Extraídos de las síntesis; requieren revisión antes de publicarse.</span><button className="btn btn-ghost sm" data-testid="review-subtopic-drafts" onClick={onReview}>Revisar subtemas<ArrowUpRight size={14} /></button></div>
    {syntheses.filter(s => ["failed", "processing", "no_sections"].includes(s.subtopics_status)).map(s => <div className="subtopic-sync-row" key={s.id} data-testid={`subtopic-extraction-state-${s.id}`}><span>{s.title || s.fecha_label} · {s.subtopics_status === "no_sections" ? "Sin apartados suficientes" : s.subtopics_error || "Extracción pendiente"}</span><button className="btn btn-ghost sm" data-testid={`retry-subtopics-${s.id}`} disabled={!!busy} onClick={() => retry(s.id)}><RefreshCw size={14} />{busy === s.id ? "Extrayendo…" : "Reintentar"}</button></div>)}
  </section>;
};